import { BaseMutationTypes } from '../BaseMutationTypes';

export class DocumentsToStoreMutationTypes extends BaseMutationTypes {
  public static readonly SelectedDocumentToStoreDocumentType = 'SELECTED_DOCUMENTS_TO_STORE_DOCUMENT_TYPE';
  public static readonly SetDocumentsLookupState = 'SET_DOCUMENTS_LOOKUP_STATE';
}
